<template>
    <b-row align-v="center" style="min-height: 100vh" class="mt-5 mb-5">
        <b-col>
            <slot name="header"/>
            <b-alert v-model="alert.show" :variant="alert.variant || 'info'" dismissible id="login-alert">{{alert.message}}</b-alert>
            <div class="col text-center mt-3">
                <img src="/konametrix.png" width="195px"/>
            </div>
            <h2 style="margin-bottom: 35px; color:#fff; text-align:center; margin-top:15px">
                Forgot password
            </h2>
            <b-form @submit.prevent="sendMail" style="color:white">
                <b-form-group label="Email:" label-for="input-1" style="margin:0 auto 26px auto; width:98%;">
                    <b-form-input id="input-1" v-model="form.email" type="text" required />
                </b-form-group>
                <div class="col text-center mt-5">
                    <b-button type="submit" variant="light">Submit</b-button>            
                </div>
                <div class="col text-center mt-5" slot="footer">
                    <b-link @click="auth_navigation">
                        Return to Log In
                    </b-link>
                </div>
            </b-form>
        </b-col>
    </b-row>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'App',
        data() {
            return {
                form:{},
                alert:{
                    show:false, 
                    message:'', 
                    variant:''
                },
            }
        },
        methods: {
            async sendMail(){
                try{
                    document.getElementById('login_top').scrollIntoView({behavior: 'smooth' })
                    this.alert = {show: true, message: "Waiting for Response..."}
                    const { data } = await axios.put(
                        process.env.VUE_APP_API_USER_URL + "users/password/reset", 
                        this.form,
                        { headers: {'Access-Control-Allow-Origin': '*'}}
                    )
                    this.alert = {show: true, message: "An email with a temporary password has been sent", variant: 'success'}
                    setTimeout(() => {
                        this.$emit('auth_navigation', false)
                    }, 5000)
                } catch(e){
                    e.response && e.response.data && e.response.data.message
                    ? this.alert = {show: true, message: e.response.data.message, variant: 'danger'}
                    : this.alert = {show: true, message: "Unable to send email", variant: 'danger'}
                }
            },
            auth_navigation(){
                this.$emit('auth_navigation', false)
            }
        }
    }
    
</script>

<style scoped>
    .col {
        max-width: 640px!important; 
        margin: auto
    }

    a {
        color:white; 
        text-align:center; 
        margin:auto
    }

</style>
